import { HttpResult } from "widgets-for-react";

// Find specific data
export const GetEventTemplate = (id: string) => `/api/v1/evenementen/eventTemplate/${id}`
export const GetEvent = (eventId: string) => `/api/v1/evenementen/event/${eventId}`
export const GetEventTemplateByEventId = (eventId: string) => `/api/v1/evenementen/eventTemplateByEvent/${eventId}`
export const GetAccount = (accountId: string) => `/api/v1/evenementen/account/${accountId}`
export const GetEventSession = (eventSessionId: string) => `/api/v1/evenementen/eventSession/${eventSessionId}`
export const GetEventProduct = (eventProductId: string) => `/api/v1/evenementen/eventProduct/${eventProductId}`
export const GetCMSPage = (slug: string) => `/api/v1/pages/all/${slug}`
export const GetCoursePageByCourseId = (id: string) => `/api/v1/pages/course/${id}`
export const GetEventPageByEventId = (id: string) => `/api/v1/pages/event/${id}`

// Search data
export const GetAlternativeCourses = (courseSlug: string) => `/api/v1/pages/courses/alternatives?slug=${courseSlug}`
export const GetCoursesByGroupId = (groupId: number) => `/api/v1/pages/courses/group?id=${groupId}`

export async function getData<DATA, DTO = void>(url: string, transformer?: (dto: DTO) => DATA): Promise<HttpResult<DATA>> {
  try {
    const response = await fetch(url)
    if (response.status == 204) {
      return {
        kind: "failed",
        status: response.status
      }
    }

    if (response.ok) {
      const json = await response.json();
      return {
        kind: "result",
        status: response.status,
        value: transformer ? transformer(json) : json,
      }
    }

    return {
      kind: "failed",
      status: response.status
    }
  } catch (error) {
    return {
      kind: "failed",
      status: 500
    }
  }
}
